import React, { useEffect } from 'react';
import './Formations.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { formations } from '../../data/formationsData'; // Importez les données adaptées

function Formations() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleMouseEnter = (e) => {
    e.currentTarget.classList.add('transition');
    e.currentTarget.setAttribute('data-aos', '');
  };

  return (
    <section id='formations' className="formations-container">
      <h1 className="title">Mes Formations</h1>
      <div className="formations-grid">
        {formations.map((formation, index) => (
          <div data-aos="fade-up" onMouseEnter={handleMouseEnter} className="formation-card" key={index}>
            <div>
              <div className="icon-circle">
                <span className="icon">{formation.icon}</span>
              </div>
              <h2 className="formation-title">{formation.title}</h2>
              <div className="line"></div>
              <h3 className="formation-subtitle">{formation.subtitle}</h3>
              <p className="formation-description">{formation.description}</p>
            </div>
            {formation.link && (
              <a
                href={"/img/formations/" + formation.link}
                className="formation-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Voir le diplôme
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Formations;